import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { SortBot } from '../../../app/helpers/sort';
import { Router } from '@angular/router';

import { GlobalPhoneWhitelistBasic, GlobalPhoneWhitelistBasicArray } from '@models/ss-api/responses/global.phone.whitelist.basic';
import { AddGlobalPhoneWhitelist } from 'app/dialogs/add.global.phone.whitelist.dialog/add.global.phone.whitelist.dialog';

@Component({
    selector: 'tos-phone-whitelist',
    templateUrl: './tos.phone.whitelist.component.html',
    styleUrls: ['./tos.phone.whitelist.component.scss']
})

export class TOSPhoneWhitelistComponent implements OnInit {
    IsBusy: boolean = false;

    GlobalPhoneWhitelists: GlobalPhoneWhitelistBasicArray;
    PhoneFilter: string;

    constructor(private dialogService: DialogService,
        private api: ssApiService,
        private gb: GlobalService,
        private sweetAlert: SweetAlertService,
        private router: Router) { }

    ngOnInit() {
        this.gb.SetPageTitle('TOS Phone Whitelist');

        this.GetPhones();
    }

    sortBy(sortVar1, sortVar2?) {
        this.GlobalPhoneWhitelists = SortBot.SortAuto(this.GlobalPhoneWhitelists, sortVar1, sortVar2);
    }

    GetPhones() {
        this.IsBusy = true;
        let disposable = this.api.GetGlobalPhoneWhitelists().subscribe((response) => {
            if (response.Result) {
                this.GlobalPhoneWhitelists = response.Data;
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Items',
                    text: response.Message
                }).then(() => { }, () => { });
            }
            this.IsBusy = false;
            disposable.unsubscribe();
        });
    }

    DeleteItem(item: GlobalPhoneWhitelistBasic) {

        this.IsBusy = true;

        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'The phone number will no longer be whitelisted - tickets may be generated',
            showCancelButton: true
        }).then((response) => {
            this.IsBusy = false;
            let disposable = this.api.RemoveGlobalPhoneWhitelist(item.Phone).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Phone Removed',
                        timer: 1500
                    }).then(() => { }, () => { });
                    this.GetPhones();
                } else {
                    this.sweetAlert.swal({
                        type: 'error',
                        title: 'Error',
                        text: response.Message
                    }).then(() => { }, () => { });
                }
                disposable.unsubscribe();
            });
        }, (dismiss) => {
            this.IsBusy = false;
        });

    }

    AddItem() {
        let disposable = this.dialogService.addDialog(AddGlobalPhoneWhitelist, {
            Title: 'Add Global Phone TOS Whitelist'
        }, { width: 600, height: 600 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.GetPhones();
            }
        });
    }

}
